export var Echarts = {
	echarts: require("../node_modules/echarts/lib/echarts"),
	title: require("../node_modules/echarts/lib/component/title"),
	tooltip: require("../node_modules/echarts/lib/component/tooltip"),
	bar: require("../node_modules/echarts/lib/chart/bar"),
	line: require("../node_modules/echarts/lib/component/markLine.js"),
	pie: require("../node_modules/echarts/lib/chart/pie"),
	legend: require("../node_modules/echarts/lib/component/legend")
};
